import {Container} from "pixi.js";

export enum ReduxSlices {
  Bookings = 'bookings',
  Sections = 'sections',
  Settings = 'settings',
  Resize = 'resize',
  BlockOuts = 'blockOuts',
  Service = 'service',
  FloorplanFilter = 'floorplanFilter',
  TableDrag = 'tableDrag'
}

// is use in TableBookingSlots and StatusViewContainer
export const floorplanPixiContainerId = 'floorplan-pixi-container'

export class ContainerWithId extends Container {
  private _id: string;

  get id() {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }
}

export const floorplanBGHex = '#ebebeb';
export const floorplanBGNum = 0xebebeb;
